import useReactiveZone from "reactive-zone";
import { transformHTMLToText } from "../../transform/htmlToText.transform.js";
import TaiBaseWidget from "../base.widget.js";
import dropdownTemplate from './Dropdown.template.html';
import TermAndConditionWidget from "../TermConditionWidget.js";

let dropdownInlineMode = false;


/**
 * 
 * @param {string} value 
 */
const [encodeOtherResponse, decodeOtherResponse, isStartWithOther] = (() => {
    /**
     * @param {string} value
     * @returns {string}
     *  */
    const encode = (value) => {
        return !value.startsWith("Other: ") ? `Other: ${value} ` : value;
    }

    /**
     * @param {string} value
     * @returns {string}
     *  */
    const decode = value => value.startsWith("Other: ") ? value.replace("Other: ", '') : value;

    const isStartWithOther = value => value.startsWith("Other: ") || value.startsWith("other: ")

    return [
        encode, decode, isStartWithOther
    ]
})()

class DropdownWidget extends TaiBaseWidget {

    zone = useReactiveZone(this)
    refDropDownValue = this.zone.useElementRef('ref.dropdown');
    refInputOther = this.zone.useElementRef('ref.inputOther');

    onZoneInit() {
        const { injectPropToZone, onZoneReady, injectMethodToZone, onZoneChanges, useZoneComputed, useZoneTransform, onZoneDestroy, useElementRef } = useReactiveZone(this);

        const props = {
            dropdownValue: '',
            otherValue: '',
            isOtherSelected: false,
            // listing: [
            //     { name: 'Item 1' },
            //     { name: 'Item 2' },
            //     { name: 'Item 3' },
            //     { name: 'Item 4' },
            //     { name: 'Item 5' },
            //     { name: 'Item 6' },
            // ]
            listing: Array.from(new Array(100)).map((_, i) => ({
                name: `Item ${i}`,
                id: i,
                fullName: 'Fullname ' + i,
                lastName: 'LastName ' + i,
                email: 'Email ' + i
            }))
        }

        this.props = injectPropToZone(props)

        injectMethodToZone({
            onDropdownChanged: this.onDropdownChanged.bind(this),
            doClick: () => alert('123'),
            itemClick: (item) => { alert(item.name) }
        })

        onZoneReady(() => {
            if (this.fieldModel.userResponse.length > 0 && this.isOtherSelected) {
                this.props.dropdownValue = 'Others'
                this.props.otherValue = decodeOtherResponse(this.fieldModel.userResponse);
            } else if (this.fieldModel.userResponse.length > 0) {
                this.props.dropdownValue = this.fieldModel.userResponse;
            } else {
                this.props.dropdownValue = this.fieldModel.findDefaultOptionValue() || this.fieldModel.fieldOptions[0].value;
                this.props.otherValue = '';
            }
        })

        onZoneChanges({
            "otherValue": ({ newValue, oldValue }) => {
                this.doValidate();
                for (let i = 0; i < 5; i++) {
                    this.props.listing[i] = {
                        fullName: newValue,
                        lastName: newValue
                    }
                    // this.props.listing[i].lastName = newValue
                }

            },
            "dropdownValue": ({ newValue }) => {
                // console.log("dropdownValue", newValue);
                const isOther = this.isOtherSelected;
                this.props.isOtherSelected = isOther;

                // const newList = [];
                for (let i = 0; i < 20; i++) {
                    // newList.push({
                    //     name: `Item clone: ${i} - ${newValue} - `
                    // })
                    this.props.listing[i].fullName = newValue
                    this.props.listing[i].lastName = newValue
                }
                // this.props.listing = newValue === 'Others' ? [] : newList
                if (isOther) {
                    this.refInputOther.element?.classList.remove('d-none');
                } else {
                    this.props.otherValue = '';
                    this.refInputOther.element?.classList.add('d-none');
                }
            },
        })
    }

    template() {
        return dropdownTemplate
    }

    clearValue() {
        const defaultOptionValue = this.fieldModel.findDefaultOptionValue();
        this.refDropDownValue.element.value = defaultOptionValue;
    }

    onDropdownChanged(e) {

    }


    /**
     * @returns {boolean}
     */
    get isOtherSelected() {
        if (this.props.dropdownValue === 'others') {
            return true;
        } else if (this.props.dropdownValue.trim().length === 0 && isStartWithOther(this.fieldModel.userResponse)) {
            return true;
        }
        const val = this.refDropDownValue.element?.value.toLowerCase() || '';
        return ['other', 'others'].includes(val);
    }

    getValue() {
        if (this.isOtherSelected && this.props.otherValue.trim().length > 0) {
            return encodeOtherResponse(this.props.otherValue)
        } else if (!this.isOtherSelected) {
            return this.props.dropdownValue
        }
        return '';
    }

    setValue(value) {
        if (!this.fieldModel.canSetValue(value)) {
            return;
        }
        if (dropdownInlineMode) {
            const hiddenValue = this.querySelector('input'),
                btnToggle = this.querySelector('.tai-dropdown-button');
            hiddenValue.value = value;
            let opt = this.fieldModel.fieldOptions.find(item => item.value === value);
            opt = opt ? opt.text : value;
            const el = document.createElement('div');
            el.innerHTML = opt;
            btnToggle.querySelector('span').innerText = el.innerText;
            this.doValidate();
        } else {
            super.setValue(value);
        }
    }

    onValueChanges() {

    }
}


export default DropdownWidget;